module.exports = __webpack_public_path__ + "static/media/title_0.0598f69d.svg";